import { SyncInfo } from 'modules/app/types';
import { HttpErrorResponse } from 'types';
import { ActionType, createAction, createAsyncAction } from 'typesafe-actions';

export const getSyncInfo = createAction('SYNC_INFO_GET', (action) => () => action());
export const getSyncInfoRequest = createAsyncAction('SYNC_INFO_REQUEST', 'SYNC_INFO_SUCCESS', 'SYNC_INFO_REJECTED')<
  undefined,
  SyncInfo,
  HttpErrorResponse
>();

export const syncInfoActions = {
  getSyncInfo,
  getSyncInfoRequest,
};

export type SyncInfoActions = ActionType<typeof syncInfoActions>;
